// extracted by mini-css-extract-plugin
module.exports = {"layout":"bar-chart_layout__TI4Mz","field":"bar-chart_field__aO6RK","barContainer":"bar-chart_barContainer__q9lRe","bar":"bar-chart_bar__JXY6h","value":"bar-chart_value__P2mSt"};